import { SOUND_EFFECTS } from '../configs/media/soundEffects';
// Lookup by ID
function getSoundEffectById(id) {
    return SOUND_EFFECTS.effects.find((effect) => effect.id === id);
}
export function getSoundEffectsByGame(gameId) {
    return SOUND_EFFECTS.effects.filter((effect) => effect.games?.includes(gameId) || effect.games?.includes('*'));
}
// Path and metadata
export function getSoundEffectPath(id) {
    const effect = getSoundEffectById(id);
    if (!effect)
        throw new Error(`Invalid sound effect ID: ${id}`);
    return effect.path;
}
//# sourceMappingURL=getSfx.js.map